import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.handleOutsideClick = this.closeOnOutsideClick.bind(this);
    document.addEventListener("click", this.handleOutsideClick);
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick);
  }

  toggleMenu(event) {
    event.preventDefault();
    event.stopPropagation();

    const isHidden = this.menuTarget.style.display === "none" || this.menuTarget.style.display === "";

    // Ensure only one certification dropdown is open at a time.
    document.querySelectorAll('[data-certification-menu-target="menu"]').forEach((menu) => {
      if (menu !== this.menuTarget) {
        menu.style.display = "none";
      }
    });

    this.menuTarget.style.display = isHidden ? "block" : "none";
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.style.display = "none";
    }
  }

  viewAllImages() {
    // Handle view all images action
    console.log("View All Images clicked");
  }

  viewCertificationPDF() {
    // Handle view certification PDF action
    console.log("View Certification in PDF clicked");
  }

  // Define other actions for different menu items
}
